export interface TokenEntity {
  access_token:  string;
  token_type:    string;
  refresh_token: string;
  expires_in:    number;
  scope:         string;
  id:            number;
  jti:           string;
}

export class Convert {
  public static toTokenEntity(json: any): TokenEntity {
    let id = 0;

    // 尝试从 access_token 中解析用户ID
    if (json.access_token) {
      try {
        // JWT token 的格式是 header.payload.signature
        const parts = json.access_token.split('.');
        if (parts.length === 3) {
          // 解码 payload（第二部分）
          // 处理base64 padding问题
          let payload64 = parts[1];
          // 添加必要的padding
          while (payload64.length % 4) {
            payload64 += '=';
          }

          const payloadJson = atob(payload64);
          const payload = JSON.parse(payloadJson);
          id = payload.user_id || payload.id || 0;
        }
      } catch (error) {
        console.error('Failed to parse user ID from JWT token:', error);
      }
    }

    return {
      access_token: json.access_token,
      token_type: json.token_type,
      refresh_token: json.refresh_token,
      expires_in: json.expires_in,
      scope: json.scope || '',
      id: id,
      jti: json.jti || ''
    } as TokenEntity;
  }  public static tokenEntityToJson(value: TokenEntity): string {
    return JSON.stringify(value, null, 2);
  }
}
